export default "__VITE_ASSET__Cg7Hf1z3__"